/**
 * PDF.js worker served from our own origin.
 *
 * Previously every call site loaded the worker from
 * `https://unpkg.com/pdfjs-dist@<version>/build/pdf.worker.min.js`, which fails
 * outright on an air-gapped install and forces `https://unpkg.com` into the CSP
 * `script-src` and `worker-src`. `scripts/copy-pdf-worker.js` now copies the file
 * out of `node_modules/pdfjs-dist` into `public/pdfjs/` on every `prestart` /
 * `prebuild`, so the served copy always matches the installed version.
 *
 * One file serves every call site: `react-pdf@8.0.2` pins `pdfjs-dist@3.11.174`
 * exactly — the same instance `@react-pdf-viewer/core` resolves to — so the
 * `<Worker>` consumers and `pdfjs.GlobalWorkerOptions` share one worker build.
 */
export const PDF_WORKER_URL = `${process.env.PUBLIC_URL}/pdfjs/pdf.worker.min.js`;
